export default __webpack_public_path__ + "static/media/PrintsImage01.9040bd9e.jpg";